// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".info-title[data-v-45318c40]{font-size:1.75rem!important;font-weight:500!important;letter-spacing:0!important;line-height:1.286!important}@media (min-width:600px){.info-title[data-v-45318c40]{font-size:2.25rem!important;font-weight:500!important;letter-spacing:0!important;line-height:1.22!important}}.info-content[data-v-45318c40]{max-width:920px}.info-section-container[data-v-45318c40]{padding-bottom:90px;padding-top:30px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
